import React, { useEffect, useRef, useState } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import SingleOrderForm from './SingleOrderForm';
import BulkOrderForm from './BulkOrderForm';
import { useUnsavedChanges } from 'context/UnsavedChangesContext';

const CustomPopover = ({title}) => {
  const [showPopover, setShowPopover] = useState(false);
  const [isSingle, setIsSingle] = useState(false);
  const [isBulk, setIsBulk] = useState(false);
  
   const { isBlocked } = useUnsavedChanges();

  // poover ref
  const popoverRef = useRef(null);
  // effect for handling the outside clicks
  useEffect(()=>{
    const handleClickOutside=(event)=>{
      // poover is down and the click is not inside the pooverref element
      if(popoverRef.current && !popoverRef.current.contains(event.target)){
        setShowPopover(false);
      }
    }

    // add event listener when the popover is shown
    if(showPopover){
      document.addEventListener('mousedown',handleClickOutside)
    }

    // clean up to remove the listener
    return ()=>{
      document.removeEventListener('mousedown',handleClickOutside)
    }
  },[showPopover])

  const handleAddSuccess = ()=>{
    console.log("added successfully")
    setIsSingle(false)
    setShowPopover(false)
  }
  
  const handleBulkAddSucess=()=>{
    console.log("Buld added sucessfully")
    setIsBulk(false)
    setShowPopover(false)
  }

  // const openSingleModal=()=>{
  //   setIsSingle(true)
  //   setShowPopover(false)
  // }

  // const openBulkModal=()=>{
  //   setIsBulk(true)
  //   setShowPopover(false)
  // }
   // <-- NEW: Modified function with the unsaved changes check
  const openSingleModal = () => {
    // Check for unsaved changes first
    if (isBlocked) {
      if (!window.confirm('You have unsaved changes. Are you sure you want to create a new order? Your current changes will not be saved.')) {
        // If the user clicks "Cancel", do nothing.
        return; 
      }
    }
    // If not blocked, or if the user confirmed, proceed to open the modal.
    setIsSingle(true);
    setShowPopover(false);
  };

  // <-- NEW: Modified function with the unsaved changes check
  const openBulkModal = () => {
    // Check for unsaved changes first
    if (isBlocked) {
      if (!window.confirm('You have unsaved changes. Are you sure you want to create a new order? Your current changes will not be saved.')) {
        // If the user clicks "Cancel", do nothing.
        return;
      }
    }
    // If not blocked, or if the user confirmed, proceed to open the modal.
    setIsBulk(true);
    setShowPopover(false);
  };

  return (
    <>
    <div style={{ position: 'relative', display: 'inline-block' }} ref={popoverRef}>
      <span
        onClick={() => setShowPopover(prev => !prev)}
        className={`nav-link ${showPopover ? 'active' : ''}`}
        style={{ cursor: 'pointer', color: '#ffffff' }}
      >
        {title}
      </span>

      {showPopover && (
        <div
          style={{
            position: 'absolute',
            top: '110%',
            left: '50%',
            transform: 'translateX(-50%)',
            backgroundColor: '#ffffff',
            border: '1px solid #ddd',
            borderRadius: '8px',
            padding: '16px',
            zIndex: 9999,
            minWidth: '180px',
            boxShadow: '0px 8px 20px rgba(0, 0, 0, 0.15)',
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            animation: 'fadeIn 0.2s ease-in-out',
          }}
        >
          <button
            className="btn btn-secondary"
            onClick={openSingleModal}
          >
            Single Order
          </button>

         

          <button
            className="btn btn-secondary"
            onClick={openBulkModal}
          >
            Bulk Order
          </button>

          
        </div>
      )}
    </div>

    {/* single ordder */}
       <Modal
            isOpen={isSingle}
            size="xl"
            backdrop="static"
            keyboard={false}
            toggle={()=>setIsSingle(false)}
            fullscreen="xl"
            fade
            scrollable
          >
            <ModalHeader
              close={
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setIsSingle(false)}
                />
              }
            >
              Create Single Order
            </ModalHeader>
            <ModalBody>
              <SingleOrderForm 
                isEditMode={false}
                onSuccess={handleAddSuccess}
              />
            </ModalBody>
          </Modal>

      {/* bulk order */}
      <Modal
            isOpen={isBulk}
            size="xl"
            backdrop="static"
            keyboard={false}
            toggle={()=> setIsBulk(false)}
            fullscreen="xl"
            fade
            scrollable
          >
            <ModalHeader
              close={
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setIsBulk(false)}
                />
              }
            >
              Create Bulk Order
            </ModalHeader>
            <ModalBody>
              <BulkOrderForm onSuccess={handleBulkAddSucess}/>
            </ModalBody>
          </Modal>
      </>
  );
};

export default CustomPopover;
